export default __webpack_public_path__ + "static/media/blog03.96cdf2ff.jpg";